import axios from "axios";
import { format, isBefore } from "date-fns";
import React, { Fragment, useEffect, useState } from "react";
import styled from "styled-components";
import { getAreaPath } from "../../shared/getAreaPath";
import { PAHT_BY_INSTRUCTOR } from "../../shared/pathByInstructor";
import { PAHT_BY_LEVEL } from "../../shared/pathByLevel";
import { PAHT_BY_PLACE } from "../../shared/pathByPlace";
const Component = (props) => (React.createElement(Fragment, null, props.loading ? (React.createElement("div", { className: "message" }, "\u30AF\u30E9\u30B9\u60C5\u5831\u3092\u53D6\u5F97\u4E2D...")) : props.error ? (React.createElement("div", { className: "message" }, " \u30C7\u30FC\u30BF\u53D6\u5F97\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u518D\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044")) : (["月曜", "火曜", "水曜", "木曜", "金曜", "土曜", "日曜"].flatMap((day) => {
    var _a;
    return ((_a = props.classRecordsByDay[day]) === null || _a === void 0 ? void 0 : _a.length) > 0
        ? props.classRecordsByDay[day].map((record) => {
            var _a;
            return (React.createElement("div", { className: "user-item", key: record.$id },
                React.createElement("div", { className: "user-title" },
                    record.new_class_flg === "true" && (React.createElement("a", { className: "new-class-item underline", href: `${getAreaPath()}/class/new-class.html` }, "New Class")),
                    React.createElement("a", { href: `${getAreaPath()}${record.hp_genre_page_path}`, className: "underline" }, record.jenre)),
                React.createElement("div", { className: "d-flex j-between" },
                    React.createElement("div", { className: "user-img" },
                        React.createElement("img", { src: `/images/${(_a = props.teacherRecords.find((t) => t.$id === record.teacher_id)) === null || _a === void 0 ? void 0 : _a.hp_teacher_img_name}`, alt: "\u8B1B\u5E2B\u306E\u753B\u50CF" })),
                    React.createElement("div", { className: "user-content" },
                        React.createElement("p", null,
                            React.createElement("a", { className: "underline", href: `${getAreaPath()}${PAHT_BY_INSTRUCTOR[record.teacher_name]}` }, record.teacher_name)),
                        React.createElement("p", null,
                            record.date,
                            " ",
                            format(new Date(`2020-01-01T${record.start_time}`), "HH:mm"),
                            " -",
                            " ",
                            format(new Date(`2020-01-01T${record.end_time}`), "HH:mm")),
                        React.createElement("p", null,
                            React.createElement("a", { className: "underline", href: `${getAreaPath()}${PAHT_BY_LEVEL[record.level]}` }, record.level),
                            " ",
                            React.createElement("a", { className: "underline", href: `${getAreaPath()}${PAHT_BY_PLACE[record.lesson_place]}` }, record.lesson_place)),
                        record.trial_lesson_flg !== "false" ? (React.createElement("a", { className: "btn-round btn-arrow-right", href: `${getAreaPath()}/reservation.html?id=${Number(record.$id)}` },
                            "\u4F53\u9A13\u7533\u3057\u8FBC\u307F ",
                            React.createElement("img", { src: "/images/ico-arrow-right-white.png", alt: "\u4F53\u9A13\u7533\u3057\u8FBC\u307F" }))) : (React.createElement("span", { className: "class-full" }, "\u6E80\u54E1\u5FA1\u793C"))))));
        })
        : [];
}))));
const StyledComponent = styled(Component) `
> button {...}
`;
const Container = (props) => {
    const [classRecordsByDay, setClassRecordsByDay] = useState({});
    const [teacherRecords, setTeacherRecords] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    useEffect(() => {
        (async () => {
            setLoading(true);
            try {
                const res = (await axios.get(`https://api.tryupdance.com/class-info/classes`, {
                    params: { area: props.area },
                })).data;
                setTeacherRecords(res.teachers);
                // 曜日ことに分ける
                const classRecordsByDay = res.classes.reduce((acc, record) => {
                    var _a;
                    acc[record.date] = [...((_a = acc[record.date]) !== null && _a !== void 0 ? _a : []), record];
                    return acc;
                }, {});
                // それぞれの曜日について開始時間でソートする
                Object.keys(classRecordsByDay).forEach((day) => classRecordsByDay[day].sort((a, b) => isBefore(new Date(`2020-01-01T${a.start_time}`), new Date(`2020-01-01T${b.start_time}`)) ? -1 : 1));
                setClassRecordsByDay(classRecordsByDay);
            }
            catch (err) {
                setError(true);
                throw err;
            }
            finally {
                setLoading(false);
            }
        })();
    }, [props.area]);
    console.log(classRecordsByDay);
    return (React.createElement(StyledComponent, { classRecordsByDay: classRecordsByDay, loading: loading, error: error, teacherRecords: teacherRecords }));
};
export default Container;
